export function alphabeticalSort(a, b, isAsc = true) {
  return isAsc ? a.localeCompare(b) : b.localeCompare(a)
}

export function numericSort(a, b, isAsc = true) {
  return isAsc ? a - b : b - a
}
